module.exports = __webpack_public_path__ + "static/img/middle-ggqy.3c1b179.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/middle-ggqy.png
// module id = 91Sj
// module chunks = 9